import { PublicHomePage } from "@/features/hca-public";
import { PublicShellWithDiagnoza } from "@/route-helpers/public-shell-with-diagnoza";
import { usePageMeta } from "@/shared/seo/use-page-meta";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: HomeRoute,
});

function HomeRoute() {
  usePageMeta({ path: "/" });
  return (
    <PublicShellWithDiagnoza>
      <PublicHomePage />
    </PublicShellWithDiagnoza>
  );
}
